//CRIANDO ACTION

import { createAction, props } from '@ngrx/store';
import { IService } from 'src/app/shared/interfaces/service/service';

//padrão de nomenclatura tudo maiusculo
enum ServiceActionType {
  //textos para acomparnharmos os estados de load SERVICE
  LOAD_SERVICE = '[SERVICE] load SERVICE from api',
  LOAD_SERVICE_SUCCESS = '[SERVICE] load SERVICE from api return success',
  LOAD_SERVICE_ERROR = '[SERVICE] load SERVICE from api return error',
  SAVE_SERVICE = '[SERVICE] save SERVICE from api',
  SAVE_SERVICE_SUCCESS = '[SERVICE] edit SERVICE from api return success',
  EDIT_SERVICE = '[SERVICE] edit SERVICE from api',
  EDIT_SERVICE_SUCCESS = '[SERVICE] edit SERVICE from api return success',
  EDIT_SERVICE_ERROR = '[SERVICE] edit SERVICE from api return error',
  DELETE_SERVICE= '[SERVICE] delete SERVICE from api'
}
export const loadService = createAction(
  ServiceActionType.LOAD_SERVICE
);
export const loadServiceSuccess = createAction(
  ServiceActionType.LOAD_SERVICE_SUCCESS,
  props<{ lista: IService[] }>()
);
//vai para o effects
export const saveService = createAction(
  ServiceActionType.SAVE_SERVICE,
  props<{ service: IService }>()
);
//vai para o reducer
export const saveServiceSuccess = createAction(
  ServiceActionType.SAVE_SERVICE_SUCCESS,
  props<{ service: IService }>()
);
//vai para o effects
export const editService = createAction(
  ServiceActionType.EDIT_SERVICE,
  props<{ service: IService; id: number }>()
);
//vai para o reducer
export const editServiceSuccess = createAction(
  ServiceActionType.EDIT_SERVICE_SUCCESS,
  props<{ service: IService }>()
);

export const editServiceError = createAction(
  ServiceActionType.EDIT_SERVICE_ERROR,
  props<{ description: string }>()
);

export const deleteService = createAction(
  ServiceActionType.DELETE_SERVICE,
  props<{ id: any }>()
);


